var React = require('react');

function LiquorIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.3 12.63L14.7 24.2c-.4.4-1 .4-1.4 0L1.7 12.63c-.4-.4-.4-1.04 0-1.43l2.6-2.57c.4-.4 1-.4 1.4 0l8.3 8.3 8.3-8.3c.4-.4 1-.4 1.4 0l2.6 2.57c.4.4.4 1.03 0 1.43z"}));
}

LiquorIcon.displayName = "LiquorIcon";

LiquorIcon.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = LiquorIcon;

LiquorIcon.default = LiquorIcon;
